<template>
  <div class="Invite">
    <label for="">学校/机构：</label>
    <my_input :inputStyle="style" v-model="value"></my_input>
  </div>
</template>

<script>
 import MyInput from '@/components/Input.vue'
 export default {
   name: '',
   data () {
     return {
       value: ''
     }
   },
   watch: {
     value (v) {
       this.update(v)
     }
   },
   methods: {
     update(v) {
       this.$store.commit('updateEnrollOrg', v);
     }
   },
   computed: {
     style() {
       return {
         background: 'transparent',
         height: '1.8em',
         color: 'white',
         width: '9.6vw',
         'border-bottom': '1px solid #F8E900'
       }
     }
   },
   components: {
     my_input: MyInput
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Invite{
   width: 62.5vw;
   height: 4.375vw;
   background: linear-gradient(15deg, #4345f9, #6160ff);
   box-sizing: border-box;
   padding-left: 3.6vw;
   color: white;
   font-weight: 500;
   border-radius: 2px;
   display: flex;
   justify-content: flex-start;
   align-items: center;
 }
</style>
